import { combineReducers } from 'redux';

import failure from './authenticationFailureReducer';

export default combineReducers({
    failure
});